// extracted by mini-css-extract-plugin
export default {"businessReportContainer":"BusinessPreRegisterReportPage_businessReportContainer__u0s8E"};